import { MessageSquare as MessageSquareIcon } from "@tamagui/lucide-icons";
import { Circle, FullscreenSpinner, Paragraph, Subheadline3, YStack } from "@medbillai/ui";
import type { CaseListFilters } from "../utils/types";
const getEmptyTitle = ({
  showRead,
  showUnread,
  showClosed
}: CaseListFilters): string => {
  const allFiltersOn = showRead && showUnread && showClosed;
  return allFiltersOn ? "No cases yet" : "No cases match the selected filters";
};
type EmptyCaseListProps = CaseListFilters & {
  loading: boolean;
};
export const EmptyCaseList = ({
  loading,
  showRead,
  showUnread,
  showClosed
}: EmptyCaseListProps) => {
  return <YStack jc="center" ai="center" f={1} gap="$4" p="$sp4" minHeight={200} $sm={{
    gap: "$2"
  }} height="100%" data-sentry-element="YStack" data-sentry-component="EmptyCaseList" data-sentry-source-file="EmptyCaseList.tsx">
      {loading ? <FullscreenSpinner /> : <YStack testID="case-list.empty-state" alignItems="center" justifyContent="flex-start" gap="$2" $platform-web={{
      maxWidth: 400,
      mx: "$5"
    }}>
          <YStack alignItems="center">
            <Circle size="$8" backgroundColor="$surface0" zIndex={2} justifyContent="center" alignItems="center" $platform-web={{
          size: "$6"
        }}>
              <MessageSquareIcon size="$1.5" strokeWidth={2} color="$iconDefault" />
            </Circle>
          </YStack>
          <Subheadline3 numberOfLines={2} pt="$2" textAlign="center">
            {getEmptyTitle({
          showRead,
          showUnread,
          showClosed
        })}
          </Subheadline3>
          <Paragraph theme="alt1" px="$8" textAlign="center">
            Start a new case to get your health and billing questions answered.
          </Paragraph>
        </YStack>}
    </YStack>;
};